import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Link from 'components/Link';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import s from './VocCardSlider.scss';
import VocCard from '../../../../../components_v2/common/VocCard';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import makeRequest from '../../../../../utils/makeRequest';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';

class VocCardSlider extends React.Component {
  constructor() {
    super();
    this.state = {
      items: [],
    };

    this.ref = React.createRef();
  }

  componentDidMount() {
    const { sectionData } = this.props;

    const subSections = sectionData?.subSections;

    //for loading content
    if (subSections && !Array.isArray(subSections) && subSections.dataUrl) {
      this.loadSectionData(subSections.dataUrl);
    }
  }

  loadSectionData = dataUrl => {
    if (
      this.props.sectionData.items &&
      Array.isArray(this.props.sectionData.items)
    ) {
      return;
    }
    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data && data.data && data.data.items && data.data.items.length > 0) {
        this.setState({
          items: data.data.items,
        });
      }
    });
  };

  sendGA = data => {
    sendGaThroughProps({
      data,
    });
  };

  sendGAOnCLick = (item, index, typeofcard, vsSectionName) => {
    let data = {};
    const { clickGaAction, gaLabelConnector } = this.props;
    const connector = gaLabelConnector || '_';
    if (typeof item.gaData !== 'undefined' && item.gaData.gaAction) {
      data = item.gaData;
    } else if (clickGaAction) {
      data.gaAction = clickGaAction;
      data.gaLabel = `${index + 1}${connector}${item.wu}`;
    } else {
      data.gaAction = `${typeofcard}${vsSectionName}`;
      data.gaLabel = `${index + 1}${connector}${item.wu}`;
    }

    sendGaThroughProps({
      data,
    });
  };

  getUpdatedData = resetCallback => {
    if (this.state.nextUrl) {
      makeRequest.get(this.state.nextUrl, 'skipfeedengine').then(data => {
        if (data && data.data && data.data.items) {
          this.setState({
            items: [...this.state.items, ...data.data.items],
            nextUrl: data.data.nextPageData,
          });

          if (data.data.nextPageData && typeof resetCallback === 'function') {
            setTimeout(resetCallback, 0);
          }
        }
      });
    }
  };

  customOnError = e => {
    e.target.onerror = null;
    e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
  };

  render() {
    if (!this.props.sectionData || this.props.sectionData.length === 0) {
      return null;
    }

    const sectionData = this.props.sectionData || this.state.sectionData;
    const vocSectionItems = sectionData.items || this.state.items;
    const headerClickGa = this.props;

    const headerGaAction =
      headerClickGa && headerClickGa.gaAction
        ? headerClickGa.gaAction
        : `${sectionData.name}Section_Actions`;
    const headerGaLabel =
      headerClickGa && headerClickGa.gaLabel
        ? headerClickGa.gaLabel
        : 'HeadingClick';

    const settings = {
      arrows: true,
      dots: true,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite: false,
    };
    return (
      <>
        {sectionData.border === 'top' && (
          <InterSectionBorder border={sectionData.border} />
        )}
        <div className={`${s.vocCardWrap} slick_UI`}>
          <Listingheader
            headingname={sectionData.name}
            doNotChangeURL
            doNotChangeDomain
            headingLink={sectionData.link || sectionData.path}
            newga={`${headerGaAction}#${headerGaLabel}`}
            target={sectionData.target}
            ga4Type={sectionData?.ga4Type}
            ga4Category={sectionData?.ga4Category}
          />
          {!this.props.isWapView && (
            <Slider {...settings} ref={this.ref}>
              {vocSectionItems &&
                Array.isArray(vocSectionItems) &&
                vocSectionItems.length > 0 &&
                vocSectionItems
                  .slice(0, 3)
                  .map((val, index) => (
                    <VocCard
                      title={val?.hl}
                      msid={val?.msid}
                      imagesize={val?.imagesize}
                      imageid={val?.imageid}
                      seopath={val?.seo}
                      isWapView={this.props.isWapView}
                      source={val?.source}
                      index={index}
                      gaIndex={index + 1}
                      metainfo={val?.metainfo}
                      wu={val?.wu}
                      dl={val?.dl}
                      syn={val?.syn}
                      author={val?.au}
                      width={val?.imageWidth}
                      overridelink={val?.overridelink}
                      otherPageWidget
                    />
                  ))}
            </Slider>
          )}
          {this.props.isWapView && (
            <div className={s.mobileScroll}>
              {vocSectionItems &&
                Array.isArray(vocSectionItems) &&
                vocSectionItems.length > 0 &&
                vocSectionItems.slice(0, 3).map((val, index) => (
                  <Link
                    doNotChangeURL
                    doNotChangeDomain
                    to={`${sectionData.link || sectionData.path}#voc_${
                      val?.msid
                    }`}
                    ga4Data={
                      sectionData.ga4Type && [
                        {
                          event: 'user_click',
                          type: `${sectionData.ga4Type}`,
                          category: 'story_click',
                          story_no: `${index + 1}`,
                          msid: val?.msid,
                        },
                      ]
                    }
                  >
                    <VocCard
                      title={val?.hl}
                      msid={val?.msid}
                      imagesize={val?.imagesize}
                      imageid={val?.imageid}
                      seopath={val?.seo}
                      isWapView={this.props.isWapView}
                      source={val?.source}
                      index={index}
                      gaIndex={index + 1}
                      metainfo={val?.metainfo}
                      wu={val?.wu}
                      dl={val?.dl}
                      syn={val?.syn}
                      author={val?.au}
                      width={val?.imageWidth}
                      overridelink={val?.overridelink}
                      otherPageWidget
                      noLinkMobile
                    />
                  </Link>
                ))}
            </div>
          )}
        </div>
        {sectionData.border === 'bottom' && (
          <InterSectionBorder border={sectionData.border} />
        )}
      </>
    );
  }
}
VocCardSlider.contextType = UseIntersectionObeserver;
VocCardSlider.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    id: PropTypes.string,
  }),
  gaData: PropTypes.shape({}),
  clickGaAction: PropTypes.string,
  wrapperClass: PropTypes.string,
  gaLabelConnector: PropTypes.string,
  isWapView: PropTypes.bool,
  headerClickGa: PropTypes.shape({}),
  target: PropTypes.string,
  ga4Type: PropTypes.string,
  gaIndex: PropTypes.number,
};
VocCardSlider.defaultProps = {
  sectionData: {},
  gaData: null,
  clickGaAction: null,
  wrapperClass: '',
  gaLabelConnector: '',
  isWapView: false,
  headerClickGa: undefined,
  ga4Type: '',
  gaIndex: '',
  target: '_blank',
};

export default VocCardSlider;
